import { render, staticRenderFns } from "./AccountGroupList.vue?vue&type=template&id=10f00889&scoped=true&"
import script from "./AccountGroupList.vue?vue&type=script&lang=js&"
export * from "./AccountGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f00889",
  null
  
)

export default component.exports